import React from "react";
import "./Group136.css";

function Group136(props) {
  const { className } = props;

  return (
    <div className={`group-136 ${className || ""}`}>
      <div className="group-135">
        <div className="group-container">
          <div className="group-132">
            <div className="group-131">
              <div className="group-130"></div>
            </div>
          </div>
          <div className="group-134"></div>
        </div>
      </div>
    </div>
  );
}

export default Group136;
